import type {Moment} from "moment";
import {RoomPeopleConfiguration} from "./RoomPeopleConfiguration";
import {isEqual} from "lodash-es";
import type {GetAvailability} from "../MessageTypes/GetAvailability";

export class ReservationSearchData {
    //@ts-ignore
    dateFrom: null|Moment = null;
    //@ts-ignore
    dateTo: null|Moment = null;
    adultCount: null|number = 1;
    childrenAges: number[] = [];
    /**
     * Unikatowy id wyszukiwanego pokoju,
     * używany w rezerwacjach grupowych aby określić do którego pokoju teraz szukamy
     */
    uniqueId = 0;
    roomStandardIds?: number[] = undefined;
    topRoomStandardIds?: number[] = undefined;
    chanceId?: number = undefined;
    offerIds?: number[] = undefined;
    packetId: null|number = null;
    discountCode: null|string = null;
    setNextUniqueId() {
        this.uniqueId = RoomPeopleConfiguration.nextId++;
    }
    getConfigurationId() {
        return RoomPeopleConfiguration.getConfigurationId(this.adultCount as number, this.childrenAges);
    }
    getPeopleConfiguration() {
        const result = new RoomPeopleConfiguration();
        result.adultCount = this.adultCount;
        result.childrenAges = this.childrenAges;
        result.uniqueId = this.uniqueId;
        return result;
    }
    get childrenCount(): number {
        return this.childrenAges?.length || 0;
    }
    set childrenCount(newCount: number) {
        if(!newCount) {
            this.childrenAges = [];
        } else {
            for(let i = 0; i < newCount; i++) {
                if(this.childrenAges.length <= i) {
                    this.childrenAges[i] = 5;
                }
            }
            this.childrenAges.length = newCount;
        }
    }

    /**
     * Chwilowo nie używane, dodatkowe konfiguracje osób (do rezerwacji grupowej)
     * Zamiast tego jest teraz używany GroupReservationBasket - który zawiera inne rezerwacje grupowe
     * Patrz {@link ../MessageTypes/SetGroupReservationBasket.ts}
     */
    extraRooms:RoomPeopleConfiguration[] = [];
    addRoom(): RoomPeopleConfiguration {
        const newRoom = new RoomPeopleConfiguration();
        this.extraRooms.push( newRoom)
        return newRoom;
    }
    //Tworzy nowy obiekt ReservationSearchData na podstawie zdeserializowanego
    public static deserialize(data: any){

        const result = new ReservationSearchData();
        Object.assign(result,data);
        if (typeof(result.dateFrom) == 'string') {
            result.dateFrom = self.moment(result.dateFrom);
        }
        if (typeof(result.dateTo) == 'string') {
            result.dateTo = self.moment(result.dateTo);
        }
        result.extraRooms = [];
        if(data.extraRooms?.length) {
            for(let _extraRoom of data.extraRooms) {
                const extraRoom = new RoomPeopleConfiguration();
                Object.assign(extraRoom,_extraRoom);
                result.extraRooms.push(extraRoom);
            }
        }
        return result;
    }
    public applyNewSearchData(newSearchData:ReservationSearchData):string[]|false {
        let anythingChanged = false;
        let changedFields = [];
        for(let k in newSearchData) {
            // @ts-ignore
            const oldValue = this[k];
            // @ts-ignore
            const newValue = newSearchData[k];
            if(oldValue != newValue) {
                if(typeof(oldValue) == 'object' && typeof(newValue) == 'object') {
                    if(self.moment.isMoment(oldValue) && self.moment.isMoment(newValue) && oldValue.isSame(newValue)) {
                        continue;
                    }
                    if(isEqual(oldValue,newValue)) {
                        continue;
                    }
                }
                changedFields.push(k);
                anythingChanged = true;
            }
            //@ts-ignore
            this[k] = newValue;
        }
        if(anythingChanged) {
            return changedFields;
        } else {
            return false;
        }
    }

    public isMatchingToAvailabilityRequest(availabilityRequest: GetAvailability ): boolean {
        if (this.dateFrom === null
            || this.dateTo === null
            || this.adultCount === null) {
            return false;
        }

        if (this.dateFrom.format('YYYY-MM-DD') !== availabilityRequest.fromDate) {
            return false;
        }

        if (this.dateTo.format('YYYY-MM-DD') !== availabilityRequest.toDate) {
            return false;
        }

        if (this.adultCount != availabilityRequest.adultsCount) {
            return false;
        }

        if (!isEqual(this.packetId, (availabilityRequest.packetId ?? null))) {
            return false;
        }

        if (!isEqual(this.discountCode, (availabilityRequest.discountCode ?? null))) {
            return false;
        }

        if (!isEqual(this.childrenAges, availabilityRequest.childAges)) {
            return false;
        }

        if (!isEqual(this.offerIds ?? null, availabilityRequest.filterOffers ?? null)) {
            return false;
        }

        if (!isEqual(this.roomStandardIds ?? null, availabilityRequest.filterStandards ?? null)) {
            return false;
        }
        return true;
    }
}

